import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import Spinner from 'react-spinkit';
import _ from 'lodash';

import Card from '../components/bootstrap/Card';
import CardHeader from '../components/bootstrap/CardHeader';
import CardBlock from "../components/bootstrap/CardBlock";
import CopyAssignmentLinks from "../components/CopyAssignmentLinks";
import SortedDropboxesSelector from "../selectors/SortedDropboxesSelector";
import { INSTRUCTOR } from "../constants/roles";
import {
    ASSIGNMENTS__REQUESTED,
    ASSIGNMENTS__COPY__REQUESTED,
    DROPBOXES__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";

class AssignmentCopyAllPage extends AuthorizedComponent {

    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.state = {
            errors: null,
            targetDropbox : null
        };

        this.handleDropboxChange = this.handleDropboxChange.bind(this);
        this.handleAssignmentAllCopy = this.handleAssignmentAllCopy.bind(this);
        this.getSourceDropbox = this.getSourceDropbox.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, params, roles_self } = this.props,
            { dropboxName } = params
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.name === dropboxName) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (_.size(assignments) < 1) {
                    dispatch({
                        type: ASSIGNMENTS__REQUESTED,
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    componentWillReceiveProps(newProps) {
        const { errors, targetDropbox } = newProps;
        this.state = {
            targetDropbox : targetDropbox,
            errors: errors
        };
    }

    checkAssignmentCollisions(sourceDropbox, targetDropbox){

        const { assignments } = this.props,
            sourceAssignments = _.filter(
                assignments, assignment => {
                    return assignment.dropbox.name === sourceDropbox.name;
                }
            ),
            targetAssignments = _.filter(
                assignments, assignment => {
                    return assignment.dropbox.name === targetDropbox.name;
                }
            )
        ;

        let collisions = _.remove(
            _.map(sourceAssignments, source_assignment => {
                return _.head(
                    _.filter(
                        targetAssignments,
                        ['name', source_assignment.name]
                    )
                );
            }),
            n => {
                return n !== undefined;
            }
        );

        if (collisions.length > 0){
            this.setState({
                errors: _.map(collisions, collision =>{
                    return `Duplicate assignment name ${collision.name} is not allowed.`;
                })
            });
            return true;
        }else{
            return false;
        }
    }

    handleDropboxChange(event){
        const { dropboxes } = this.props,
            { value } = event.target,
            dropbox = value > -1 ? dropboxes[value]: null
        ;

        this.setState({
            targetDropbox: dropbox,
        });
    }

    handleAssignmentAllCopy(e) {
        e.preventDefault();

        const { targetDropbox } = this.state,
            { params } = this.props,
            sourceDropbox = this.getSourceDropbox(params.dropboxName)
        ;

        if (targetDropbox) {
            if (!this.checkAssignmentCollisions(sourceDropbox, targetDropbox)) {
                this.props.dispatch({
                    type: ASSIGNMENTS__COPY__REQUESTED,
                    payload: {
                        destinationDropboxId: targetDropbox.id,
                        sourceDropboxId: sourceDropbox.id,
                    }
                });
            }
        }
    }

    getSourceDropbox(dropboxName) {
        return _.last(
            _.filter (this.props.dropboxes, (dropbox) => {
                return dropbox.name === dropboxName;
            })
        );
    }

    renderCourseOptions(dropbox) {
        const { params, roles_self } = this.props;

        return (
            [
                _.includes(
                    _.flatMap(
                        roles_self,
                        dropbox_role => {
                            if (dropbox_role.dropbox.id === dropbox.id) {
                                return dropbox_role.role;
                            }
                        }
                    ),
                    INSTRUCTOR
                ) && this.getSourceDropbox(params.dropboxName) !== dropbox.name
                ?
                    <option value={dropbox.id}>
                        {dropbox.name}
                    </option>
                :
                    null
            ]
        );
    }

    render() {
        const isLoading = this.props.request.sendingRequest;
        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { dropboxes, params } = this.props,
            { errors } = this.state,
            dropbox = this.getSourceDropbox(params.dropboxName)
        ;

        return dropbox
        ?
            <div className="col-md-12">
                <div className="action-links">
                    <CopyAssignmentLinks
                        dropbox={dropbox}
                        onClickSubmit={this.handleAssignmentAllCopy}
                    />
                </div>
                <h3>{dropbox.name}</h3>
                {
                    errors && errors.map(
                        (error, i) => {
                            return (
                                <Card key={"error_"+i} >
                                    <div className="alert alert-danger alert-dismissible" role="alert">
                                        {error}
                                    </div>
                                </Card>
                            );
                        },
                        this
                    )
                }
                <Card>
                    <CardBlock>
                        {   dropboxes
                            ? (
                                <Card>
                                    <CardHeader className="bg-primary">Copy all Assignments</CardHeader>
                                    <CardBlock>
                                        <form className="border-top-0">
                                            Copying all assignments from:
                                            <div className="ml-1 mt-3 mb-3">
                                                <h5>{dropbox.name}</h5>
                                            </div>
                                            To Course:
                                            <br/>
                                            <div className="mt-3">
                                                <select
                                                    onChange={this.handleDropboxChange}
                                                    className="custom-select"
                                                >
                                                    <option>---Select a Course---</option>
                                                    {
                                                        _.map(
                                                            SortedDropboxesSelector(this.props),
                                                            this.renderCourseOptions.bind(this)
                                                        )
                                                    }
                                                </select>
                                            </div>
                                        </form>
                                    </CardBlock>
                                </Card>
                            ) : (
                                null
                            )
                        }
                    </CardBlock>
                </Card>
            </div>
        : null
        ;
    }
}

AssignmentCopyAllPage.propTypes = {
    auth: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { assignments, auth, dropboxes, request, roles_self } = state;

    return { assignments, auth, dropboxes, request, roles_self };
}

export default connect(mapStateToProps)(withRouter(AssignmentCopyAllPage));



/** WEBPACK FOOTER **
 ** ./src/containers/AssignmentCopyAllPage.js
 **/